import { rem } from 'polished';
import styled from 'styled-components';

export const StyledForm = styled.form`
  padding: ${rem('24px')};
  border-radius: ${'16px'};
  background-color: ${({ theme }) => theme.colors.cross.ultralightGray};
  margin-bottom: ${rem('32px')};
  width: 100%;
`;

export const StyledFieldset = styled.div`
  border: 0;
  padding: 0;
  margin: 0;
  min-width: 0;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${rem('16px')};

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.m}) {
    flex-direction: column;
    align-items: start;
  }
`;

export const StyledLegend = styled.legend`
  display: table;
  float: left;
  margin: 0;
  padding: 0;

  + * {
    clear: both;
  }

  font-size: ${rem('18px')};
  font-weight: 700;
`;

export const StyledMultiCheckboxWrapper = styled.div`
  display: inline-flex;
  gap: ${rem('16px')};
`;
